import {FC, ReactNode, useEffect} from 'react'
import {useHistory} from 'react-router-dom'

interface Props {
  children: ReactNode
  clientRoleType: string
  employmentStatus?: string
  redirectPath: string
}

export const RejectUnemployeeRouter: FC<Props> = ({children, clientRoleType, employmentStatus, redirectPath}) => {
  const isUnEmployee = clientRoleType === 'member' && (!employmentStatus || employmentStatus === 'unemployed')
  const history = useHistory()

  useEffect(() => {
    if (isUnEmployee) {
      history.push(redirectPath)
    }
  }, [])

  return <>{!isUnEmployee && <>{children}</>}</>
}
